(function () {
  'use strict';
  var root = document.querySelector('.al-editorial main');
  if (!root) return;
  var bar = document.querySelector('.al-editorial .bar');
  var opening = root.querySelector('.prose, .lead');
  var frame = false;
  function updateBar() {
    frame = false;
    if (!bar) return;
    var pastOpening = opening ? opening.getBoundingClientRect().top <= window.innerHeight * 0.4 : true;
    var visible = window.scrollY >= window.innerHeight * 0.75 && pastOpening;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', String(!visible));
    bar.inert = !visible;
  }
  function requestBar() {
    if (frame) return;
    frame = true;
    window.requestAnimationFrame(updateBar);
  }
  updateBar();
  window.addEventListener('scroll', requestBar, { passive: true });
  window.addEventListener('resize', requestBar);
  window.addEventListener('pageshow', requestBar);
  window.addEventListener('load', requestBar, { once: true });

  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches) return;
  var pending = new Set();
  var running = new Map();
  var observer;
  function reveal(element, instant) {
    pending.delete(element);
    if (observer) observer.unobserve(element);
    element.classList.remove('al-reveal-pending');
    if (instant || motion.matches) return;
    var animation = element.animate([
      { opacity: 0, transform: 'translate3d(0, 64px, 0)' },
      { opacity: 1, transform: 'translate3d(0, 0, 0)' }
    ], { duration: 950, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'none' });
    running.set(element, animation);
    animation.onfinish = animation.oncancel = function () { running.delete(element); };
  }
  function stop() {
    if (observer) observer.disconnect();
    pending.forEach(function (element) { element.classList.remove('al-reveal-pending'); });
    pending.clear();
    running.forEach(function (animation) { animation.cancel(); });
    running.clear();
  }
  try {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) reveal(entry.target, false);
      });
    }, { threshold: 0, rootMargin: '0px 0px -48px 0px' });
    var selector = 'figure, main > h2, .sign > h2, .badges, .disc, .rules, .test, .score, .tests, .actives, .timeline, .offer, .guar, .note, .box, .dose, blockquote, .al-pull, .triad, .exp, .vid, .ph, .tl > .st, .comments > .fb';
    var candidates = Array.from(root.querySelectorAll(selector));
    candidates.filter(function (element) {
      return !candidates.some(function (parent) { return parent !== element && parent.contains(element); });
    }).forEach(function (element) {
      if (element.getBoundingClientRect().top >= window.innerHeight) {
        pending.add(element);
        element.classList.add('al-reveal-pending');
        observer.observe(element);
      }
    });
    root.addEventListener('focusin', function (event) {
      pending.forEach(function (element) {
        if (element === event.target || element.contains(event.target)) reveal(element, true);
      });
      running.forEach(function (animation, element) {
        if (element === event.target || element.contains(event.target)) animation.cancel();
      });
    });
    if (motion.addEventListener) motion.addEventListener('change', function () { if (motion.matches) stop(); });
    window.addEventListener('beforeprint', stop);
  } catch (_) { stop(); }
})();
